import type { TFunction } from "i18next";

import type { Job } from "@/lib/api/jobs";

const FALLBACK_LABELS: Record<string, string> = {
  sync_variables: "Sync Variables",
  sync_master_items: "Sync Master Items",
  sync_app: "Sync App",
  sync_group: "Sync Group",
  audit_group: "Audit Group",
  audit_all_groups: "Audit All Groups",
  sync_all_groups: "Sync All Groups",
  analyze_app: "App Analysis",
  analyze_qvds: "Storage Analysis",
  collect_capacity: "Capacity Consumption",
  collect_reloads: "Reload Collection",
  poll_app_evaluation: "App Evaluation Polling",
};

export function getJobTypeLabel(type: Job["type"] | string): string {
  return FALLBACK_LABELS[type] ?? type;
}

export function makeJobTypeLabeler(t: TFunction): (type: Job["type"] | string) => string {
  return (type) => t(`jobTypes.${type}`, { defaultValue: getJobTypeLabel(type) });
}
